import React from 'react';
import { Button } from '@chakra-ui/react';

const SendButton = ({ onOpenModal, isDisabled = false }) => {
  return (
    <Button
      w="170px"
      py="22px"
      fontWeight="400"
      fontSize="14px"
      mb="30px"
      onClick={() => onOpenModal('send')}
      variant="black"
      mr="10px"
      isDisabled={isDisabled}
    >
      Send
    </Button>
  );
};

export default SendButton;
